module.exports = __webpack_public_path__ + "img/home-services-03.24e84b91.webp";